import React, { useEffect, useState } from 'react'
import InputCelPhone from 'components/Checkout/CheckoutSteps/Identificacion/InputCelPhone';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import { actionsType } from 'config/constants';
import Loader from 'components/Loader';
import NewRelicService from 'services/NewRelic';
import Rut from 'components/Forms/Inputs/InputRut'
import { formatRut } from 'utils';
import style from './style.scss';//NOSONAR

const ClientUpdate = (props) => {
    const { payload } = props;

    const [user, setUser] = useState(null);
    const [phoneIsValid, setPhoneIsValid] = useState(false);
    const [phoneValue, setPhoneValue] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [rutValue, setRutValue] = useState((payload.value.user && payload.value.user.document) ? payload.value.user.document : '');
    const [rutIsValid, setRutIsValid] = useState(false);
    const [formIsValid, setFormIsValid] = useState(false);
    const callbackSuccess = payload?.value?.callbackSuccess || (() => {});

    useEffect(() => {
        if (payload) {
            setUser(payload.value ? payload.value.user : null);
            setPhoneValue((payload.value && payload.value.user ? payload.value.user.phone : ''))

        }

        if (rutValue) {
            setRutValue(payload.value.user.document)
            setRutIsValid(true)
        } else {
            setRutValue('')
            setRutIsValid(false)
        }
    }, [])

    useEffect( () => {
        const isvalid = (rutIsValid)
        if (isvalid !== formIsValid) {
            setFormIsValid(isvalid)
        }
    }, [rutIsValid, phoneIsValid])

    const phoneValid = (phone) => { 
        isValid(true);
        if (phone) {
            setPhoneValue(phone)
        }
    }

    const isValid = (valid) => {
        setPhoneIsValid(valid);
    }

    const rutValid = (valid, value) => {
        setRutIsValid(valid)
        setRutValue(value)
    }

    const onSubmit = () => {
        setLoading(true)

        callbackSuccess({document: rutValue, phone: phoneValue})
            .then(() => {
                setLoading(false)
                goBack()
            })
        
        NewRelicService.sendPageAction({
            action: 'updateClientSubmit',
            payload: {
                status: 'init'
            }
        })
    }

    const goBack = () => {
        setTimeout(() => PubSub.dispatch(actionsType.DRAWER.UPDATE_CLIENT_CLOSE),0);
    }

    let isClientValid = payload.value.user && payload.value.user.document;

    return (
        <>
            <div className="drawer-container">
                <h1 className="drawer-title">Datos Personales</h1>
                <div className='drawer-scroll'>
                    {isLoading && <div className="update-client-loader"><Loader /></div>}
                    <div className="client-update-container">
                        <div className="client-update-box-container">
                            <div className="client-update-box-wrapper">
                                <span className="client-update-name">Nombre</span>
                                <span className="client-update-value">{`${user && user.firstName ? user.firstName : ''} ${user && user.lastName ? user.lastName : ''}`}</span>
                            </div>
                            <div className="client-update-box-wrapper">
                                <span className="client-update-name">Mail de contacto</span>
                                <span className="client-update-value">{user && user.email ? user.email : ''}</span>
                            </div>
                            {isClientValid && <div className="client-update-box-wrapper">
                                <span className="client-update-name">RUT</span>
                                <span className="client-update-value">{user && user.document ? formatRut(user.document) : ''}</span>
                            </div>}
                        </div>
                        <div className="client-update-information-line"></div>
                        {!isClientValid && <div className="client-update-rut-wrap">
                            <span className="client-information-rut required">RUT</span>
                            <div className="client-update-rut-information-wrap">
                                <Rut placeholder={'Eje: 11.111.111-1'} callbackisValid={rutValid} defaultRut={payload.value.user.document}/>
                            </div>
                        </div>}
                        <div className="client-update-phone-wrap">
                            <span className="client-information-phone required">Télefono</span>
                            <div className="client-update-phone-information-wrap">
                                <InputCelPhone  phone={phoneValue} callback={phoneValid} callbackisValid={isValid} callbackOnkeyPress={onSubmit}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="drawer-actions">
                    <button className="secundary-btn" onClick={goBack}>Cancelar</button>
                    <button className={phoneIsValid ? 'primary-btn' : 'disabled-btn'} onClick={onSubmit}>Guardar</button>  
                </div>
            </div>
        </>
    )
}

ClientUpdate.propTypes = {
    payload: PropTypes.object
};

export default ClientUpdate;
